import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';

import {Line} from './line';

export class BasicLine extends Line {
  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService,
              public isAvg: boolean) {
    super(chart, translate, localization);

    this.getPeriodAggregateData(this.categories).forEach((elementArray: number[], key: string) => {
      const chartData: any = {
        type: 'line',
        smooth: true,
        name: key,
        data: elementArray
      };

      if (this.isAvg) {
        chartData.markLine = this.getMarkLine();
        chartData.markPoint = this.getMarkPoint();
      }
      this.series.push(chartData);
      this.pushTableRow(key, elementArray);
    });
  }
}
